import { type FacePerson } from '~/swr-hooks/person/types';

export const hasUnnamedPerson = (person?: Pick<FacePerson, 'firstName' | 'lastName'>) =>
  !person || (!person.firstName && !person.lastName);
